import React from 'react';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import {faSpinnerThird} from '@fortawesome/pro-solid-svg-icons';
import styles from './TableLoader.module.sass';

const TableLoader = () => {
    return <div className={styles['tableloader']}>
        <FontAwesomeIcon icon={faSpinnerThird} />
    </div>;
}

export default TableLoader;